const AUTH_CRITICAL_PATHNAMES = new Set([
  '/bookmarks',
  '/my-favorite',
  '/playlist',
  '/playlist/[id]',
  '/profile',
]);

export const isAuthCriticalRoute = (pathname: string): boolean => {
  return AUTH_CRITICAL_PATHNAMES.has(pathname);
};

export const isGtmAllowedRoute = (pathname: string): boolean => {
  return !isAuthCriticalRoute(pathname);
};
